import {Triggers} from "./triggers";
import {Cpu} from "./cpu";
import {Psu} from "./psu";

export class Reservation {

constructor(
  public id: string,
  public club: string,
  public court: string,
  public end: number,
  public endDateTime: string,
  public localStartDateTime: string,
  public localEndDateTime: string,
  public start: number,
  public startDateTime: string,
  public transactionId: string,
  public now: number,
  public nowDateTime: string,
  public type: string,
  public triggers?: Triggers
) {
}

  static toReservation(r:any): Reservation {

    let reservation = <Reservation>({
      id: r.id,
      club: r.club,
      court: r.court,
      end: r.end,
      endDateTime: r.endDateTime,
      localStartDateTime: r.localStartDateTime,
      localEndDateTime: r.localEndDateTime,
      start: r.start,
      startDateTime: r.startDateTime,
      transactionId: r.transactionId,
      now: r.now,
      nowDateTime: r.nowDateTime,
      type: r.type,
      triggers: r.triggers? Triggers.toTriggers(r.triggers) : { startupTime: 0, startTime: 0, endTime: 0, closedownTime: 0 }
    });

    //console.log('Parsed reservation:', JSON.stringify(reservation));
    return reservation;
  }

  static fromJson({id, club, court, end, endDateTime, localStartDateTime, localEndDateTime, start, startDateTime, transactionId, now,
                  nowDateTime, type, triggers}) {
    return new Reservation(id, club, court, end, endDateTime, localStartDateTime, localEndDateTime, start, startDateTime, transactionId, now,
      nowDateTime, type, triggers);
  }

  static fromJsonArray(json : any[]) : Reservation[] {
    return json.map(Reservation.fromJson);
  }

}
